module.exports = __webpack_public_path__ + "assets/img/chartCard-domain.8d981e67.svg";